var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              { staticStyle: { padding: "10px 25px" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "demo-ruleForm",
                    attrs: { inline: true, model: _vm.form }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "向左转" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择快递公司",
                              multiple: ""
                            },
                            on: { change: _vm.setting },
                            model: {
                              value: _vm.form.cpid,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cpid", $$v)
                              },
                              expression: "form.cpid"
                            }
                          },
                          _vm._l(_vm.shipping_company, function(shipping, key) {
                            return _c("el-option", {
                              key: key,
                              attrs: { label: shipping, value: key.toString() }
                            })
                          }),
                          1
                        ),
                        _vm._v("\n            (其他快递默认向右)\n          ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "快递限重配置" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("保存")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm._l(_vm.shipping_company_weight_limit, function(
                      weight_limit
                    ) {
                      return _c(
                        "el-form-item",
                        {
                          key: weight_limit.shipping_company,
                          attrs: { label: weight_limit.shipping_company }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80px" },
                            model: {
                              value: weight_limit.weight_limit,
                              callback: function($$v) {
                                _vm.$set(weight_limit, "weight_limit", $$v)
                              },
                              expression: "weight_limit.weight_limit"
                            }
                          }),
                          _vm._v("\n            KG\n          ")
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ecd07c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ecd07c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/WeighTurnSetting.vue
// module id = null
// module chunks = 